export function setValueAsNumberOrNull(v: unknown) {
  return v === null || Number.isNaN(Number(v)) || v === '' ? null : Number(v);
}
